import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthLoginService } from 'src/app/pages/login/services/auth-login.service';

@Component({
  selector: 'app-nav-user',
  templateUrl: './nav-user.component.html',
  styleUrls: ['./nav-user.component.css'],
})
export class NavUserComponent {
  constructor(private router: Router, private auth: AuthLoginService) {}

  name!: string;
  contractor!: any;
  async ngOnInit() {
    const userState = await this.auth.returnUserInfoV2('LOADED');

    if (!userState) return;

    this.name = userState.user.full_name ?? 'Usuario';
    this.contractor =
      userState.user.contractor?.name ?? 'Sin contratista asignada';
  }

  navigate(route: string) {
    //navegador de routes
    this.router.navigate([route]);
  }
  cambiarSistema() {
    this.router.navigate(['/system-select']);
  }
  logout() {
    this.auth.logout();
  }
}
